// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"b8b6fd6b","377":"2cb31831","527":"2a03eeae","635":"b4c41b52"}[chunkId] + ".chunk.js";
};